import * as QS from "querystring";

export interface Supporter {
    name: string;
    message: string;
    amount: number;
    timestamp: number;
  }

export default class API {

    public static isProduction = process.env.NODE_ENV === "production";

    public static endpoint = "https://us-central1-react-native-ui-kits.cloudfunctions.net/";

    public static async supporters(): Promise<Supporter[]> {
        const url = `${API.endpoint}supporters`;
        const response  = await fetch(url, {
            method: "POST",
            headers: {
                "Accept": "application/json, text/plain, */*",
                "Content-Type": "application/json"
            }
        });
        const json = await response.json();
        return json;
    }

    public static async subscribe(email: string) {
        const url = `${API.endpoint}subscribe?${QS.stringify({ email })}`;
        try {
            await fetch(url, {
                mode: "no-cors",
                method: "POST"
            });
        } catch (e) {
            // do nothing...
        }
    }

    // tslint:disable-next-line
    static async addGithubCollaborator(params: { key: string, username: string, email: string, repo: string }): Promise<{ ok?: boolean }> {
        const url = `${API.endpoint}addGithubCollaborator?${QS.stringify(params)}`;
        const response  = await fetch(url, {
            method: "POST",
            headers: {
                "Accept": "application/json, text/plain, */*",
                "Content-Type": "application/json"
            }
        });
        const json = await response.json();
        return json;
    }

    public static async testFlight(params: { firstName: string, lastName: string, email: string, project: string }) {
        const url = `${API.endpoint}testFlight?${QS.stringify(params)}`;
        const response = await fetch(url, { method: "POST" });
        if (response.status === 500) {
            throw new Error(await response.text());
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/API.ts